import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "designVersion", "visible", "invertedColor", "rootRect", "selectingTarget", "targetRect"];
import React from 'react';
import { compose, setDisplayName } from 'recompose';
import omitProps from '@hocs/omit-props';
import Layout from '@bubble-ui/primitive-layout';
import View from '@bubble-ui/primitive-view';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import filterStyle from './filterStyle';
import Mesh from './Mesh';
import withKeyboardEvents from './withKeyboardEvents';

var Grid = function Grid(_ref) {
  var children = _ref.children,
      designVersion = _ref.designVersion,
      visible = _ref.visible,
      invertedColor = _ref.invertedColor,
      rootRect = _ref.rootRect,
      selectingTarget = _ref.selectingTarget,
      targetRect = _ref.targetRect,
      props = _objectWithoutProperties(_ref, _excluded);

  var left = targetRect.left - rootRect.left;
  var top = targetRect.top - rootRect.top;
  return /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
    style: {
      position: 'relative'
    }
  }), function () {
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Mesh, {
      width: targetRect.width !== 0 ? targetRect.width : rootRect.width,
      height: targetRect.height !== 0 ? targetRect.height : rootRect.height,
      left: left > 0 ? left : 0,
      top: top > 0 ? top : 0,
      visible: visible,
      selectingTarget: selectingTarget,
      invertedColor: invertedColor,
      designVersion: designVersion
    }), /*#__PURE__*/React.createElement(View, {
      style: visible ? filterStyle : {}
    }, children));
  });
};

export default compose(withDesignVersion, setDisplayName('Grid'), withKeyboardEvents, omitProps('designVersion'))(Grid);
//# sourceMappingURL=Grid.js.map